module.exports = __webpack_public_path__ + "files/6717c6d837e67019a910f05f0f80af8f.png";